import { ErrorMessageWrapper } from '@terminal/components/error-message-wrapper/ErrorMessageWrapper';
import clsx from 'clsx';

import styles from './ConnectionsEmptyOrError.module.scss';

const CONNECTIONS_EMPTY_IMAGE =
  '/app/static/images/empty-state/radio-telescope.png';

const EMPTY_IMAGE_SIZE = {
  compact: 80,
  full: 160,
} as const;

type ConnectionsEmptyOrErrorLayout = 'fixed' | 'fillContainer';
type ConnectionsEmptyOrErrorImageSize = 'compact' | 'full';
type ConnectionsEmptyOrErrorErrorSize = 'compact' | 'fullView';

type ConnectionsEmptyOrErrorEmptyProps = {
  variant: 'empty';
  title?: string;
  layout?: ConnectionsEmptyOrErrorLayout;
  imageSize?: ConnectionsEmptyOrErrorImageSize;
};

type ConnectionsEmptyOrErrorErrorProps = {
  variant: 'error';
  errorSize?: ConnectionsEmptyOrErrorErrorSize;
  title?: string;
};

export type ConnectionsEmptyOrErrorProps =
  | ConnectionsEmptyOrErrorEmptyProps
  | ConnectionsEmptyOrErrorErrorProps;

export const ConnectionsEmptyOrError = (
  props: ConnectionsEmptyOrErrorProps
) => {
  if (props.variant === 'error') {
    const errorSize = props.errorSize ?? 'compact';
    const isFullView = errorSize === 'fullView';

    return (
      <div
        className={clsx({
          [styles.errorFullView]: isFullView,
          [styles.errorCompact]: !isFullView,
        })}
      >
        <ErrorMessageWrapper
          variant="error"
          showBorder={false}
          displayIcon
          className={styles.errorMessage}
        />
      </div>
    );
  }

  const layout = props.layout ?? 'fixed';
  const isFillContainer = layout === 'fillContainer';
  const imageSize = props.imageSize ?? 'compact';
  const imageDimension = EMPTY_IMAGE_SIZE[imageSize];

  return (
    <div
      data-connections-empty
      className={clsx(styles.emptyContent, {
        [styles.fillContainer]: isFillContainer,
      })}
    >
      <img
        src={CONNECTIONS_EMPTY_IMAGE}
        width={imageDimension}
        height={imageDimension}
        alt=""
      />
      <div className={styles.emptyTitle}>{props.title}</div>
    </div>
  );
};
